import { PhoneCall } from '@/api'

export default {
  namespaced: true,

  state: ({
    histories: []
    // call history DIFINITIONS
    // id: self.id,
    // owner: self.owner_narrative_phone_id,
    // owner_device_id: self.owner_device_id,
    // owner_name: self.owner.name,
    // owner_account_name: self.owner.account_name,
    // owner_icon_img_path: self.owner.icon_img_path,
    // owner_theme_color: 
    // zoom_meeting_id: self.zoom_meeting_id,
    // zoom_meeting_password: self.zoom_meeting_password,
    // callback_url: self.callback_url,
    // triggered_at: self.triggered_at,
    // call_end_at: self.call_end_at,
    // state: self.state,
    // attendees: [
        // id: self.id,
        // narrative_phone_id: self.narrative_phone_id,
        // device_id: self.device_id,
        // attendee_name: self.user.name,
        // attendee_account_name: self.user.account_name,
        // attendee_icon_img_path: self.user.icon_img_path,
        // attendee_theme_color: 
        // joined: joined,
        // respound_at: self.respound_at,
        // hang_uped_at: self.hang_uped_at,
        // reject: self.reject,
        // reject_message: self.reject_message,
        // call_result: self.call_result
    // ]

  }),

  mutations: {
    setHistories(state, payload) {
      state.histories = payload
    },
    
    addHistories(state, payload) {
      state.histories = state.histories.concat(payload)
    }
  },

  getters: {
    // missedHistories: state => {
    //   return state.histories.filter((h) => !h.attendees.joined )
    // }
  },

  actions: {
    // 初期読み込み
    fetch({commit}) {
      return PhoneCall.fetchHistories({ limit: 100, offset: 0}).then(res => {
        console.log(res)
        commit('setHistories', res.data.phone_calls)
      }).catch(() => {
        commit('addHistories', [])
      })
    },
    // 追加読み込み
    loadMore({state, commit}) {
      return PhoneCall.fetchHistories({ limit: 100, offset: state.histories.length }).then(res => {
        console.log(res)
        commit('addHistories', res.data.phone_calls)
      }).catch(() => {
        commit('addHistories', [])
      })
    }
  }
}